<template>
  <v-container class="col-md-6.col-6 pa-0">
    <!-- slot for parent component to activate the file changer -->
    <div class="d-flex justify-center"  @click="launchFilePicker()">
      <slot name="activator"></slot>
    </div>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input type="file"
       ref="file"
       :name="uploadFieldName"
       @change="onFileChange($event.target.name, $event.target.files)"
       style="display:none">
    <!-- error dialog displays any potential error messages -->
    <v-dialog v-model="errorDialog" max-width="300">
      <v-card>
        <v-card-text class="subheading">{{errorText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="errorDialog = false" flat>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'image-input',
    data: ()=> ({
      errorDialog: null,
      errorText: '',
      uploadFieldName: 'file',
      maxSize: 3500
    }),
    props: {
    // Use "value" to enable using v-model
      value: Object,
    },
    methods: {
      launchFilePicker(){
        this.$refs.file.click();
      },
      onFileChange(fieldName, file) {

        const { maxSize } = this
        let imageFile = file[0]

        if (file.length>0) {
          let size = imageFile.size / maxSize / maxSize
          if (!imageFile.type.match(/image\/.*|application\/pdf/)) {
            this.errorDialog = true
            this.errorText = 'Wybierz plik (JPG|PDF)'
          } 
          else if (size>this.maxSize) {
            this.errorDialog = true
            this.errorText = 'Twój plik jest zbyt wielki! Wybierz plik o wielkosci 1MB'
          } 
          else {

            const formData = new FormData()
            formData.append(fieldName, imageFile)
            const fileName = imageFile.name
            let fileURL = null;
            let typeId = 0;
            let fileExtension = "";
            if (imageFile.type == "application/pdf") {
              typeId = 859;
              fileExtension="PDF";
            }
            else{
              typeId = 326;
              fileExtension="JPG";
            }
            fileURL = URL.createObjectURL(imageFile)
  
            const fileReader = new FileReader();
            fileReader.onload = e => {
              const fileData = new Buffer(e.target.result, "binary").toString("base64");
              this.$emit('input', { formData, fileURL, fileName, fileExtension, typeId , fileData })
            };
            fileReader.readAsArrayBuffer(imageFile);
            
          }
        }
      }
    }
  }
</script>
